document.addEventListener('DOMContentLoaded', function() {

  // ─── FORM CORPORATE (#preventivo-form) ───────────────────────────────────

  // Mappa prodotto → MOQ costruita dai data attribute delle schede
  var moqMap = {};
  document.querySelectorAll('a[data-prodotto]').forEach(function(link) {
    var prodotto = link.getAttribute('data-prodotto');
    var moq = link.getAttribute('data-moq');
    if (prodotto && moq) moqMap[prodotto.toLowerCase()] = moq;
  });

  // Funzione per aggiornare il placeholder quantità
  function aggiornaMoq(nomeProdotto) {
    var quantita = document.getElementById('quantita')
      || document.querySelector('#preventivo-form input[name="quantita"]')
      || document.querySelector('#preventivo-form input[type="number"]');
    if (!quantita) return;
    var moq = moqMap[nomeProdotto.toLowerCase()];
    if (moq) {
      quantita.placeholder = 'es. ' + moq + ' pz (minimo per questo prodotto)';
    } else {
      quantita.placeholder = 'scrivi un numero';
    }
  }

  // Click sui bottoni "Richiedi offerta" nelle schede
  document.querySelectorAll('a[data-prodotto]').forEach(function(link) {
    link.addEventListener('click', function() {
      var prodotto = this.getAttribute('data-prodotto');
      setTimeout(function() {
        var select = document.getElementById('prodotto');
        if (select && prodotto) {
          var options = select.options;
          for (var i = 0; i < options.length; i++) {
            if (options[i].value.toLowerCase() === prodotto.toLowerCase()) {
              select.value = options[i].value;
              break;
            }
          }
        }
        aggiornaMoq(prodotto);
      }, 150);
    });
  });

  // Cambio manuale del select prodotto nel form corporate
  var selectCorporate = document.getElementById('prodotto');
  if (selectCorporate) {
    selectCorporate.addEventListener('change', function() {
      if (this.value) {
        aggiornaMoq(this.value);
        var quantita = document.getElementById('quantita')
          || document.querySelector('#preventivo-form input[name="quantita"]')
          || document.querySelector('#preventivo-form input[type="number"]');
        if (quantita) quantita.value = '';
        var errore = document.getElementById('moq-errore');
        if (errore) errore.remove();
      }
    });
  }

  // Invio AJAX form corporate
  var formCorporate = document.querySelector('#preventivo-form form');
  if (formCorporate) {
    formCorporate.addEventListener('submit', function(e) {
      e.preventDefault();

      // Validazione MOQ
      var selectEl = document.getElementById('prodotto');
      var quantita = document.getElementById('quantita')
        || document.querySelector('#preventivo-form input[name="quantita"]')
        || document.querySelector('#preventivo-form input[type="number"]');
      if (selectEl && quantita) {
        var prodotto = selectEl.value;
        var moq = prodotto ? moqMap[prodotto.toLowerCase()] : null;
        if (moq && parseInt(quantita.value) < parseInt(moq)) {
          var errore = document.getElementById('moq-errore');
          if (!errore) {
            errore = document.createElement('small');
            errore.id = 'moq-errore';
            errore.style.cssText = 'display:block;margin-top:6px;color:#c0392b;font-size:0.85em;font-weight:600;';
            quantita.parentNode.insertBefore(errore, quantita.nextSibling);
          }
          errore.textContent = 'La quantità minima per questo prodotto è ' + moq + ' pz.';
          quantita.value = '';
          quantita.focus();
          return;
        } else {
          var errore = document.getElementById('moq-errore');
          if (errore) errore.remove();
        }
      }

      var data = new FormData(formCorporate);
      var submitBtn = formCorporate.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Invio in corso...';
      }

      fetch(formCorporate.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(response) {
        if (response.ok) {
          window.location.href = 'https://ubuntupack.com/pages/grazie-corporate-gifting-ubuntu-green-gifts';
        } else {
          return response.json().then(function(data) {
            throw new Error(data.error || 'Errore durante l\'invio');
          });
        }
      })
      .catch(function(error) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'INVIA RICHIESTA';
        }
        alert('Si è verificato un errore durante l\'invio. Riprova o contattaci via email.');
        console.error('Formspree error:', error);
      });
    });
  }

  // ─── FORM ACQUA (#abp-acqua-form) ────────────────────────────────────────

  var formAcqua = document.getElementById('abp-acqua-form');
  if (formAcqua) {
    formAcqua.addEventListener('submit', function(e) {
      e.preventDefault();
      var data = new FormData(formAcqua);
      var submitBtn = formAcqua.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Invio in corso...';
      }
      fetch(formAcqua.action, {
        method: 'POST',
        body: data,
        headers: { 'Accept': 'application/json' }
      })
      .then(function(res) {
        if (res.ok) {
          window.location.href = 'https://ubuntupack.com/pages/grazie-acqua-brick-ubuntu-green-gifts';
        } else {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'INVIA RICHIESTA';
          }
          alert('Errore nell\'invio. Riprova o scrivici a hello@ubuntugreengifts.com');
        }
      })
      .catch(function() {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'INVIA RICHIESTA';
        }
        alert('Errore di rete. Riprova o scrivici a hello@ubuntugreengifts.com');
      });
    });
  }

});